import { orange } from "../colors/index.js";
const warningColor = (mode)=>'light' === mode ? {
        main: orange["400"],
        highContrast: orange["700"],
        lowContrast: orange["100"]
    } : {
        main: orange["400"],
        highContrast: orange["100"],
        lowContrast: orange["800"]
    };
export { warningColor };

//# sourceMappingURL=warning.js.map